import { cookieSteup } from "oms-utils";

export const { ReadCookie, RemoveCookie, WriteCookie } = cookieSteup({
  options: {
    path: "/",
    domain: window._env_.COOKIE_DOMAIN || "",
    sameSite: true,
    secure: true,
  },
});
